<template>
  <a-card title="工单关键词映射规则">
    <a slot="extra" @click="doModalShow"> 添加 </a>
    <a-table :columns="columns" :data-source="ticketTags" :loading="loading" children-column-name="“childrens”">
      <span slot="handler" slot-scope="text, record">
        <a-select v-model="record.handler" disabled show-search mode="multiple" placeholder="工单责任人" :filter-option="utils.filterOption" style="width: 240px">
          <a-select-option v-for="(user, index) in userList" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
        </a-select>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="modalShow(record.domain_id, record.domain)">编辑</a>
      </span>
    </a-table>
    <a-drawer :width="1500" :visible="modalVisible" title="关键词组合" @close="closeModal">
      <a-button @click="onAdd()">添加</a-button>
      <a-table :columns="wordColumns" :data-source="ticketWordMap" :loading="loading">
        <span slot="word_list" slot-scope="text, record">
          <a-card>
            <a slot="extra" href="#">
              <a-select v-model="record.word_list.type" placeholder="类型" style="width: 100px" @change="do_modify(record)">
                <a-select-option v-for="(select, index) in selectOption" :key="index" :value="select.type">{{ select.type }} </a-select-option>
              </a-select>
            </a>
            <div style="padding-bottom: 5px">
              <a-select v-model="record.word_list.wordList[0].type" placeholder="类型" style="width: 100px" @change="do_modify(record)">
                <a-select-option v-for="(select, index) in selectOption" :key="index" :value="select.type">{{ select.type }} </a-select-option>
              </a-select>
              <a-select v-model="record.word_list.wordList[0].wordList" show-search mode="multiple" placeholder="词汇列表" :filter-option="utils.filterOption" style="width: 300px" @change="do_modify(record)">
                <a-select-option v-for="(ticketWord, index) in ticketWords" :key="index" :value="ticketWord.id">{{ ticketWord.title }} </a-select-option>
              </a-select>
            </div>
            <div>
              <a-select v-model="record.word_list.wordList[1].type" placeholder="类型" style="width: 100px" @change="do_modify(record)">
                <a-select-option v-for="(select, index) in selectOption" :key="index" :value="select.type">{{ select.type }} </a-select-option>
              </a-select>
              <a-select v-model="record.word_list.wordList[1].wordList" show-search mode="multiple" placeholder="词汇列表" :filter-option="utils.filterOption" style="width: 300px" @change="do_modify(record)">
                <a-select-option v-for="(ticketWord, index) in ticketWords" :key="index" :value="ticketWord.id">{{ ticketWord.title }} </a-select-option>
              </a-select>
            </div>
          </a-card>
        </span>
        <span slot="handler" slot-scope="text, record">
          <a-select v-model="record.handler" show-search mode="multiple" placeholder="工单责任人" :filter-option="utils.filterOption" style="width: 240px" @change="do_modify(record)">
            <a-select-option v-for="(user, index) in userList" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
          </a-select>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="del(record.rule_id)">删除</a>
        </span>
      </a-table>
    </a-drawer>
    <a-modal v-model="domainModalShow" title="新增业务域" @ok="handleOk">
      <a-input v-model="newWord" placeholder="请输入业务域" style="width: 300px" />
      <a-select v-model="team_id" show-search placeholder="工单责任人" :filter-option="utils.filterOption" style="width: 240px; padding-top: 10px">
        <a-select-option v-for="(team, index) in teams" :key="index" :value="team.id">{{ team.name }} </a-select-option>
      </a-select>
    </a-modal>
  </a-card>
</template>

<script>
import { getAllTeamWord, updateTicketTag, getAllTicketWord, updateTeamWord, addTicketTeamWord, doTicketTeamWordDel } from '@/api/event/problem';
import { diagramList } from '@/api/system/team';
const columns = [
  {
    title: 'ID',
    dataIndex: 'domain_id',
    key: 'domain_id',
    width: 70,
    scopedSlots: { customRender: 'domain_id' }
  },
  {
    title: '业务域',
    dataIndex: 'domain',
    key: 'domain',
    width: 140,
    scopedSlots: { customRender: 'domain' }
  },
  {
    title: '操作',
    key: 'action',
    width: 70,
    scopedSlots: { customRender: 'action' }
  }
];
const wordColumns = [
  {
    title: '规则id',
    dataIndex: 'rule_id',
    key: 'rule_id',
    width: '10%',
    scopedSlots: { customRender: 'rule_id' }
  },
  {
    title: '词组组合',
    dataIndex: 'word_list',
    key: 'word_list',
    width: '40%',
    scopedSlots: { customRender: 'word_list' }
  },
  {
    title: '负责人',
    dataIndex: 'handler',
    key: 'handler',
    width: '20%',
    scopedSlots: { customRender: 'handler' }
  },
  {
    title: '正则表达式',
    dataIndex: 'regx',
    key: 'regx',
    width: 70,
    scopedSlots: { customRender: 'regx' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 70,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  props: {
    userList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      ticketTags: null,
      loading: false,
      ticketWordMap: null,
      currentDomain: null,
      domain: null,
      fatherId: 0,
      teams: null,
      team_id: null,
      newWord: '',
      selectOption: [{ type: 'or' }, { type: 'and' }, { type: 'single' }],
      columns,
      ticketWords: null,
      wordColumns,
      tagName: '',
      domainModalShow: false,
      modalVisible: false
    };
  },
  mounted() {
    this.getConfigList();
    this.getTeamList();
  },
  methods: {
    getTeamList() {
      diagramList({ category: 1, page_size: 50 }).then(res => {
        this.teams = res.data.items;
      });
    },
    del(id) {
      doTicketTeamWordDel({ rule_id: id }).then(res => {});
    },
    closeModal() {
      this.modalVisible = false;
    },
    onAdd() {
      addTicketTeamWord({ domain_id: this.currentDomain, title: this.domain })
        .then(res => {
          const id = res.data.id;
          const wordMap = {
            handler: [],
            regx: '',
            rule_id: id,
            word_list: {
              type: '',
              wordList: [
                {
                  type: '',
                  wordList: []
                },
                {
                  type: '',
                  wordList: []
                }
              ]
            }
          };
          this.loading = false;
          this.ticketWordMap.push(wordMap);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    modalShow(id, domain) {
      this.currentDomain = id;
      this.domain = domain;
      this.modalVisible = true;
      if (id == null) {
        this.ticketWordMap = null;
      }
      if (id != null) {
        for (let i = 0; i < this.ticketTags.length; i++) {
          if (this.ticketTags[i].domain_id == id) {
            this.ticketWordMap = this.ticketTags[i].rules;
          }
        }
      }
    },
    do_modify(req) {
      updateTeamWord(req)
        .then(res => {})
        .catch(() => {
          this.loading = false;
        });
    },
    handleOk() {
      addTicketTeamWord({ domain_id: this.team_id, title: this.newWord })
        .then(res => {
          this.loading = false;
          this.domainModalShow = false;
          this.getConfigList();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    doModalShow() {
      this.team_id = null;
      this.newWord = '';
      this.domainModalShow = true;
    },
    getConfigList() {
      this.loading = true;
      getAllTicketWord()
        .then(res => {
          this.ticketWords = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      getAllTeamWord()
        .then(res => {
          this.ticketTags = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
